// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"935c8714","879":"233f748f"}[chunkId] + ".chunk.js";
};